import Vue from 'vue';
import {
  i18n,
  enumTypes,
  SKIP_OPTION,
  SKIP_UNCONDI,
  SKIP_DEFAULT_KEY,
  SKIP_OPT_END,
  SKIP_OPT_NOT,
  SKIP_OPT_INVALID,
  textTypes,
  FIELD_TYPE_CITYSELECT,
  CITYSELECT_LEVEL_PROVINCE,
  CITYSELECT_LEVEL_CITY,
  FIELD_TYPE_PHONE,
  FIELD_TYPE_IDNUMBER,
  PHONE_REGEX_HMT,
  PHONE_REGEX_OVERSEA,
  PHONE_REGEX_MAINLAND,
  IDNUMBER_REGEX_CHINAID,
} from './constant';
import CustRadio from './component/radio';
import CustCheckbox from './component/checkbox';
import CustCascader from './component/cascader';
import CustCascaderM from './component/cascaderMobile';
import CustInput from './component/input';
import topicMixin from './mixin/topic';
import {
  isUef,
  isArray,
  isNumber,
  isEmpty,
  isEmptyArray,
  isValidObject,
  deepCloneJSON,
} from './utils';
import {
  Form,
  FormItem,
  Input,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Cascader,
  Icon,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/form.css';
import 'element-ui/lib/theme-chalk/form-item.css';
import 'element-ui/lib/theme-chalk/input.css';
import 'element-ui/lib/theme-chalk/radio.css';
import 'element-ui/lib/theme-chalk/radio-group.css';
import 'element-ui/lib/theme-chalk/checkbox.css';
import 'element-ui/lib/theme-chalk/checkbox-group.css';
import 'element-ui/lib/theme-chalk/cascader.css';
import 'element-ui/lib/theme-chalk/icon.css';
import VCascader from 'vant/lib/cascader';
import VField from 'vant/lib/field';
import VPopup from 'vant/lib/popup';
import 'vant/lib/cascader/style';
import 'vant/lib/field/style';
import 'vant/lib/popup/style';
import errorIcon from './component/icon/error.vue';

if (Vue) {
  Vue.component('ElForm', Form);
  Vue.component('ElFormItem', FormItem);
  Vue.component('ElInput', Input);
  Vue.component('ElRadio', Radio);
  Vue.component('ElRadioGroup', RadioGroup);
  Vue.component('ElCheckbox', Checkbox);
  Vue.component('ElCheckboxGroup', CheckboxGroup);
  Vue.component('ElCascader', Cascader);
  Vue.component('ElIcon', Icon);
  Vue.component('VCascader', VCascader);
  Vue.component('VField', VField);
  Vue.component('VPopup', VPopup);
}

const EXTRA_SUFFIX = '_extra';
const VALIDATE_TRIGGER = 'blur';

export default {
  name: 'BasicForm',

  mixins: [topicMixin],

  props: {
    isMobile: Boolean,
    hideIndex: Boolean,
    districtData: {
      type: Array,
      default: () => [],
    },
    cityData: {
      type: Array,
      default: () => [],
    },
    provinceData: {
      type: Array,
      default: () => [],
    },
    locale: String,
    schema: {
      type: Array,
      default: () => [],
    }
  },

  data() {
    this.valSetTimer = new Map();
    this.visibilityMap = new Map();

    return {
      values: {},
      formItemHiddenMap: {},
    };
  },

  beforeDestroy() {
    this.clearSetValTimer();
  },

  computed: {
    formattedSchema() {
      const schema = deepCloneJSON(this.schema);

      return schema.map((item, index) => {
        const result = { ...item };
        const isSkip = result.isSkip;

        if (isSkip && isValidObject(isSkip.options)) {
          const nextItem = schema[index + 1];
          const nextKey = nextItem && nextItem.key;

          Object.entries(isSkip.options).forEach(([optKey, optVal]) => {
            switch(optVal) {
              case SKIP_OPT_NOT:
                isSkip.options[optKey] = nextKey;
                break;

              case SKIP_OPT_INVALID:
                break;

              default:
            }
          });
        }
        return result;
      });
    },

    schemaIndexMap() {
      const result = {};
      this.schema.forEach((item, index) => {
        result[item.key] = index;
      });
      return result;
    },
  },

  methods: {
    setValues(values) {
      this.values = deepCloneJSON(values);
    },

    i18n(key) {
      return i18n(this.locale, key);
    },

    validate(cb) {
      const formRef = this.$refs.formRef;
      if (formRef) {
        return formRef.validate(cb);
      }
    },

    isInvalidResult() {
      const visibilityValues = this.visibilityMap.values();
      for (const item of visibilityValues) {
        if (item === SKIP_OPT_INVALID) {
          return true;
        }
      }
      return false;
    },

    renderForm(h, values) {
      const rules = {};
      const _this = this;

      const formItems = this.formattedSchema.map((schemaItem = {}, index) => {
        const { key, required, type, componentAttrs = {} } = schemaItem;
        
        rules[key] = [];

        // 设置必填校验规则
        if (required) {
          rules[key].push({
            trigger: VALIDATE_TRIGGER,
            validator: (rule, value, callback) => {
              if (isEmpty(values[key])) {
                return callback(new Error(this.i18n('requiredMsg')));
              }
              callback();
            },
          });

          // 当Radio&Checkbox组件中存在需要输入的表单项时校验规则
          const options = componentAttrs.options || [];

          if (enumTypes.includes(type) && options.length) {
            const extraOptions = [];
            options.forEach((option) => {
              if (option.inputable) extraOptions.push(option.value);
            });

            if (extraOptions.length) {
              rules[key].push({
                trigger: VALIDATE_TRIGGER,
                validator: (rule, value, callback) => {
                  let formattedVal = value;
                  if (!isArray(value)) {
                    formattedVal = [value];
                  }

                  if (formattedVal.length < 1) return callback();

                  for (const valItem of formattedVal) {
                    const isExtra = extraOptions.includes(valItem);
                    if (!isExtra) continue;

                    const extraVal = values[`${valItem}${EXTRA_SUFFIX}`];

                    if (isEmpty(extraVal)) {
                      return callback(new Error(this.i18n('requiredInput')));
                    }
                  }

                  callback();
                },
              });
            }
          }
        }

        // 最小值
        const min = componentAttrs.min;
        if (isNumber(min)) {
          if (textTypes.includes(type)) {
            rules[key].push({
              trigger: VALIDATE_TRIGGER,
              validator: (rule, value, callback) => {
                const val = values[key];
                if (!isEmpty(val) && val.length < min) {
                  return callback(new Error(this.i18n('minMsg') + min));
                }
                callback();
              },
            });
          }
        }

        // 手机号格式校验
        if (type === FIELD_TYPE_PHONE) {
          const { stringency, area } = componentAttrs;

          if (stringency === 'strict') {
            let validator = [];

            area.forEach((item) => {
              switch(item) {
                case 'hmt':
                  validator = validator.concat(PHONE_REGEX_HMT);
                  break;
                case 'oversea':
                  validator = validator.concat(PHONE_REGEX_OVERSEA);    
                  break;
                default:
                  validator = validator.concat(PHONE_REGEX_MAINLAND);
              }
            });

            rules[key].push({
              trigger: VALIDATE_TRIGGER,
              validator: (rule, value, callback) => {
                if (validator.some((handler) => handler.test(values[key]))) {
                  return callback();
                }
                callback(new Error(this.i18n('phoneStrictMsg')));
              },
            });
          } else {
            rules[key].push({
              trigger: VALIDATE_TRIGGER,
              validator: (rule, value, callback) => {
                if (/^\d*$/.test(values[key])) {
                  return callback();
                }
                callback(new Error(this.i18n('phoneLooseMsg')));
              },
            });
          }
        }

        // 证件号码格式校验
        if (type === FIELD_TYPE_IDNUMBER) {
          const { stringency, idType } = componentAttrs;

          if (stringency === 'strict') {
            let validator = [];

            idType.forEach((item) => {
              if (item === 'chinaID') {
                validator = validator.concat(IDNUMBER_REGEX_CHINAID);
              }
            });

            rules[key].push({
              trigger: VALIDATE_TRIGGER,
              validator: (rule, value, callback) => {
                if (validator.some((handler) => handler.test(values[key]))) {
                  return callback();
                }
                callback(new Error(this.i18n('phoneStrictMsg')));
              },
            });
          } else {
            rules[key].push({
              trigger: VALIDATE_TRIGGER,
              validator: (rule, value, callback) => {
                if (/^[\da-zA-Z]*$/.test(values[key])) {
                  return callback();
                }
                callback(new Error(this.i18n('idNumberLooseMsg')));
              },
            });
          }
        }

        schemaItem._index = index + 1;
        return this.renderFormItem(h, schemaItem, values[key], values);
      });

      return h('ElForm', {
        class: 'customize-form',
        ref: 'formRef',
        props: {
          labelPosition: 'top',
          rules,
          model: values,
          validateOnRuleChange: false,
        },
      }, formItems);
    },

    setSkipRule(rule = {}, schema) {
      const { type, options } = rule;
      const { key } = schema;
      const multiple = this.checkIfMultiple(schema);

      if ([SKIP_OPTION, SKIP_UNCONDI].includes(type) && isValidObject(options)) {
        let defaultOptExist = false;

        const subscribeOpt = (ruleValue, ruleHandler) => {
          this.subscribe(`values.${key}`, { value: ruleValue, handler: ruleHandler});
        };

        Object.entries(options).forEach(([optKey, optTarget]) => {

          if (optTarget === SKIP_OPT_NOT) return;

          if (optKey === SKIP_DEFAULT_KEY) {
            defaultOptExist = true;
          }

          subscribeOpt(optKey, (val) => {
            if (this.formItemHiddenMap[key]) return;

            if (multiple) {
              if (isEmptyArray(val)) {
                this.recoverSkip(key);
                return;
              }
            } else {
              if (isEmpty(val)) {
                this.recoverSkip(key);
                return;
              }
            }

            switch(optTarget) {
              case SKIP_OPT_INVALID:
                this.tagFormInvalid(key);
                break;

              default:
                this.skipFormItems(key, optTarget);
            }
          });
        });

        // 添加恢复跳题机制
        if (!defaultOptExist) {
          subscribeOpt(SKIP_DEFAULT_KEY, () => {
            this.recoverSkip(key);
          });
        }
      }
    },

    recoverSkip(key) {
      this.visibilityMap.delete(key);
      this.handleSkipVisibility();
    },

    skipFormItems(startKey, endKey) {
      const newStartIndex = this.schemaIndexMap[startKey];
      const newEndIndex = endKey === SKIP_OPT_END ? this.formattedSchema.length : this.schemaIndexMap[endKey];
      const visibilityKeys = this.visibilityMap.keys();

      for (const oldStartKey of visibilityKeys) {
        const oldStartIndex = this.schemaIndexMap[oldStartKey];
        if (oldStartIndex >= newStartIndex && oldStartIndex < newEndIndex) {
          this.visibilityMap.delete(oldStartKey);
        }
      }

      this.visibilityMap.set(startKey, endKey);
      this.handleSkipVisibility();
    },

    tagFormInvalid(startKey) {
      this.visibilityMap.set(startKey, SKIP_OPT_INVALID);
      this.handleSkipVisibility();
    },

    handleSkipVisibility() {
      const visibilityValues = this.visibilityMap.values();
      const visibilityEndMap = {};

      for (const item of visibilityValues) {
        visibilityEndMap[item] = true;
      }
      
      let hidden = false;

      for (const schemaItem of this.formattedSchema) {
        const { key } = schemaItem;
        if (visibilityEndMap[key]) {
          hidden = false;
        }
        this.$set(this.formItemHiddenMap, key, hidden);
        if (this.visibilityMap.has(key)) {
          const endKey = this.visibilityMap.get(key);
          if (endKey !== SKIP_OPT_INVALID) {
            hidden = true;
          }
        }
      }
    },

    // 检查是否为多选
    checkIfMultiple(schema = {}) {
      const { componentAttrs, type } = schema;
      if (componentAttrs && componentAttrs.multiple) return true;

      if (/Checkbox$/.test(type)) return true;

      return false;
    },

    renderFormItem(h, schema = {}, value, values) {
      const _this = this;
      const { key, type, label, isSkip, required, description, _index } = schema;
      
      if (isSkip) {
        this.setSkipRule(isSkip, schema);
      }

      const commonComp = {
        Text: (h, props, value) => {
          const { key, placeholder, componentAttrs } = props;

          return h(CustInput, {
            key,
            props: {
              value,
              clearable: true,
            },
            attrs: {
              placeholder: placeholder || this.i18n('inputPlaceholder'),
              maxlength: componentAttrs && componentAttrs.max || 500,
            },
            on: {
              input(val) {
                _this.setFormValue(key, val);
              },
              blur() {
                _this.validateField(key);
              },
            },
          });
        },

        Textarea: (h, props, value) => {
          const { key, placeholder, componentAttrs } = props;

          return h(CustInput, {
            key,
            props: {
              value,
              type: 'textarea',
              clearable: true,
              showWordLimit: true,
            },
            attrs: {
              rows: 3,
              placeholder: placeholder || this.i18n('inputPlaceholder'),
              maxlength: componentAttrs && componentAttrs.max || 1000,
            },
            on: {
              input(val) {
                _this.setFormValue(key, val);
              },
              blur() {
                _this.validateField(key);
              },
            },
          });
        },

        Radio: (h, props, value, extraProps = {}) => {
          const { key, required, componentAttrs = {} } = props;
          const layout = componentAttrs.layout;
          const options = componentAttrs.options || [];

          const childrens = options.map((item) => {
            const extraKey = `${item.value}${EXTRA_SUFFIX}`;

            return h(CustRadio, {
              props: {
                label: item.value,
                checked: item.value === value,
                inputable: item.inputable,
                required,
                url: item.url,
                desc: item.desc,
                extraValue: this.values[extraKey],
                ...extraProps,
              },
              on: {
                inputExtra(val) {
                  _this.setFormValue(extraKey, val);
                },
                extraBlur() {
                  _this.validateField(key);
                },
              },
            }, item.label);
          });

          return h('ElRadioGroup', {
            class: [`customize-form-radio-col${layout}`],
            key,
            props: {
              value,
            },
            on: {
              input(val) {
                _this.setFormValue(key, val);
                if (value) {
                  _this.setFormValue(`${value}${EXTRA_SUFFIX}`);
                }
                _this.validateField(key);
              },
            },
          }, childrens);
        },

        Checkbox: (h, props, value = [], extraProps = {}) => {
          const { key, required, componentAttrs = {} } = props;
          const layout = componentAttrs.layout;
          const options = componentAttrs.options || [];

          if (!isArray(value)) {
            _this.setFormValue(key, []);
          }

          const childrens = options.map((item) => {
            const extraKey = `${item.value}${EXTRA_SUFFIX}`;

            return h(CustCheckbox, {
              props: {
                label: item.value,
                checked: value.includes(item.value),
                inputable: item.inputable,
                required,
                url: item.url,
                desc: item.desc,
                extraValue: this.values[extraKey],
                ...extraProps,
              },
              on: {
                inputExtra(val) {
                  _this.setFormValue(extraKey, val);
                },
                extraBlur() {
                  _this.validateField(key);
                },
              },
            }, item.label);
          });

          return h('ElCheckboxGroup', {
            class: [`customize-form-checkbox-col${layout}`],
            key,
            props: {
              value,
            },
            on: {
              input(val) {
                _this.setFormValue(key, val);
                _this.validateField(key);
              },
            },
          }, childrens);
        },

        ImageRadio: (h, props, value = []) => {
          const extraProps = {
            withImage: true,
          };
          return commonComp.Radio(h, props, value, extraProps);
        },

        ImageCheckbox: (h, props, value = []) => {
          const extraProps = {
            withImage: true,
          };
          return commonComp.Checkbox(h, props, value, extraProps);
        },

        Phone: (h, props, value) => {
          const { key, placeholder, componentAttrs } = props;

          return h(CustInput, {
            key,
            props: {
              value,
              clearable: true,
              type: 'tel',
            },
            attrs: {
              placeholder: placeholder || this.i18n('inputPlaceholder'),
              maxlength: componentAttrs && componentAttrs.max || 500,
            },
            on: {
              input(val) {
                _this.setFormValue(key, val);
              },
              blur() {
                _this.validateField(key);
              },
            },
          });
        },

        IDNumber: (h, props, value) => {
          const { key, placeholder, componentAttrs } = props;

          return h(CustInput, {
            key,
            props: {
              value,
              clearable: true,
            },
            attrs: {
              placeholder: placeholder || this.i18n('inputPlaceholder'),
              maxlength: componentAttrs && componentAttrs.max || 500,
            },
            on: {
              input(val) {
                _this.setFormValue(key, val);
              },
              blur() {
                _this.validateField(key);
              },
            },
          });
        },
      };
      
      // 移动端组件
      const mobileComp = {
        Cascader: (h, props, value = []) => {
          const { key, placeholder, componentAttrs = {} } = props;
          const options = componentAttrs.options || [];

          return h(CustCascaderM, {
            key,
            props: {
              value: value,
              options,
              placeholder: placeholder || this.i18n('selectPlaceholder'),
            },
            on: {
              input(val) {
                _this.setFormValue(key, val);
                _this.validateField(key);
              },
            },
          });
        },

        CitySelect: (h, props, value = []) => {
          const { componentAttrs = {}, ...restProps } = props;
          const level = componentAttrs.level;
          let options;

          switch(level) {
            case CITYSELECT_LEVEL_PROVINCE:
              options = this.provinceData;
              break;

            case CITYSELECT_LEVEL_CITY:
              options = this.cityData;
              break;

            default:
              options = this.districtData;
          }

          return mobileComp.Cascader(h, {
            ...restProps,
            componentAttrs: {
              ...componentAttrs,
              options
            },
          }, value);
        },
      };

      // PC端组件
      const pcComp = {
        Cascader: (h, props, value = []) => {
          const { key, placeholder, componentAttrs = {} } = props;
          const options = componentAttrs.options || [];

          return h(CustCascader, {
            key,
            props: {
              value: value,
              options,
              placeholder: placeholder || this.i18n('selectPlaceholder'),
            },
            on: {
              input(val) {
                _this.setFormValue(key, val);
                _this.validateField(key);
              },
            },
          });
        },

        CitySelect: (h, props, value = []) => {
          const { componentAttrs = {}, ...restProps } = props;
          const level = componentAttrs.level;
          let options;

          switch(level) {
            case CITYSELECT_LEVEL_PROVINCE:
              options = this.provinceData;
              break;

            case CITYSELECT_LEVEL_CITY:
              options = this.cityData;
              break;

            default:
              options = this.districtData;
          }

          return pcComp.Cascader(h, {
            ...restProps,
            componentAttrs: {
              ...componentAttrs,
              options
            },
          }, value);
        },
      };

      const compMap = {
        ...commonComp,
        ...(this.isMobile ? mobileComp : pcComp),
      };
      const compRender = compMap[type];

      const descRender = (h, text) => {
        return h('div', {
          class: 'customize-form-item-desc',
        }, text);
      };

      const labelRender = (label, type, h) => {
        const child = [h('span', {}, [label])];
        if (type.includes('Checkbox')) {
          child.push(
            h(
              'span',
              { class: 'customize-form-item-multitag' },
              [this.i18n('multiSelectTag')]
            )
          );
        }

        return h(
          'span',
          {},
          [child]
        );
      };

      const errorRender = (h, error) => {
        return h('div', {
          class: 'customize-form-error',
        },
        [h(errorIcon, { class: 'customize-form-error-icon' }), h('span', error)]
        );
      };

      // 跳题时删除对应表单项的值
      const needSkip = this.checkIfNeedSkip(key);
      if (needSkip) {
        this.$delete(this.values, key);
      }

      const indexPrefix = this.hideIndex ? '' : `${_index}. `;

      return !needSkip && h(
        'ElFormItem',
        {
          class: [
            'customize-form-item',
            `customize-form-item-${type.toLowerCase()}`,
            required && 'is-required',
          ],
          key,
          props: {
            prop: key,
          },
          scopedSlots: {
            error: ({ error }) => errorRender(h, error),
          },
        },
        [
          description && descRender(h, description),
          compRender && compRender(h, schema, value, values),
          h(
            'template',
            { slot: 'label' },
            [labelRender(`${indexPrefix}${label}`, type, h)]
          ),
        ],
      );
    },

    checkIfNeedSkip(key) {
      return this.formItemHiddenMap[key];
    },

    setFormValue(key, val) {
      this.clearSetValTimer(key);
      const timer = setTimeout(() => {
        if (isUef(val)) {
          this.$delete(this.values, key);
        } else {
          this.$set(this.values, key, val);
          this.$forceUpdate();
        }
      }, 30);
      this.valSetTimer.set(key, timer);
    },

    clearSetValTimer(key) {
      if (key) {
        const timer = this.valSetTimer.get(key);
        timer && clearTimeout(timer);
        return;
      }
      this.valSetTimer.values((timer) => {
        timer && clearTimeout(timer);
      });
    },

    validateField(key) {
      setTimeout(() => {
        this.$refs.formRef.validateField(key);
      }, 100);
    },

    reset() {
      this.$refs.formRef.resetFields();
      this.$forceUpdate();
    },

    getValues() {
      return this.formatValues(this.values);
    },

    formatValues(values) {
      const formattedValues = deepCloneJSON(values);

      this.schema.forEach((item) => {
        const { key, type, componentAttrs = {} } = item;

        // 处理地址选择器输出为汉字的情况
        if (type === FIELD_TYPE_CITYSELECT) {
          if (componentAttrs.output === 'name') {
            formattedValues[key] = this.formatCityOutput(formattedValues, key);
          }
        }
      });

      Object.entries(formattedValues).forEach(([key, value]) => {
        if (isEmpty(value)) {
          delete formattedValues[key];
        }
      });

      return formattedValues;
    },

    // 格式化地址选择器输出值
    formatCityOutput(values, key) {
      let cityOptions = this.districtData || this.cityData || this.provinceData;
      if (this.districtData.length) {
        cityOptions = this.districtData;
      } else if (this.cityData.length) {
        cityOptions = this.cityData;
      } else {
        cityOptions = this.provinceData;
      }

      const getName = (options, valueArr = [], result = []) => {
        if (/[\u4e00-\u9fa5]/.test(valueArr[0])) {
          return valueArr;
        }
        const value = valueArr.shift();

        for (const option of options) {
          if (option.value === value) {
            result.push(option.label);

            if (valueArr.length) getName(option.children, valueArr, result);
            break;
          }
        }

        return result;
      };

      const result = getName(cityOptions, values[key]);

      return result.length ? result : undefined;
    },
  },

  render(h) {
    return this.renderForm(h, this.values);
  },
}